var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.05 11C15.8 11 16.46 10.59 16.8 9.97L20.38 3.48C20.75 2.82 20.27 2 19.51 2H4.71L3.77 0H0.5V2H2.5L6.1 9.59L4.75 12.03C4.02 13.37 4.98 15 6.5 15H18.5V13H6.5L7.6 11H15.05ZM5.66 4H17.81L15.05 9H8.03L5.66 4ZM6.5 16C5.4 16 4.51 16.9 4.51 18C4.51 19.1 5.4 20 6.5 20C7.6 20 8.5 19.1 8.5 18C8.5 16.9 7.6 16 6.5 16ZM16.5 16C15.4 16 14.51 16.9 14.51 18C14.51 19.1 15.4 20 16.5 20C17.6 20 18.5 19.1 18.5 18C18.5 16.9 17.6 16 16.5 16Z",
    fill: "#242D30"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.dfa6c88cf254492abf7bc649db465fd6.svg";
export { ForwardRef as ReactComponent };